import(/* webpackMode: "eager" */ "/home/liamto-aality/www/apps/front/src/app/[lng]/error.tsx");
